import { UtmSource } from '../../../../../../services/exports/Constants';
import { CustomUtmSource } from '../../../../../../views/marketing/tracking-links';

export default {
  title: 'Linkuri de urmărire',
  utm_sources: {
    [UtmSource.GoogleBusinessProfile]: 'Google business',
    [UtmSource.SocialMedia]: 'Rețele sociale',
  },
  form: {
    utm_source: {
      label: 'Sursă',
      placeholder: 'Selectați sursa',
      options: {
        [UtmSource.GoogleBusinessProfile]: 'Google business',
        [UtmSource.SocialMedia]: 'Alte rețele sociale',
        [CustomUtmSource.Other]: 'Altele',
      },
    },
    utm_source_details: {
      label: 'Sursă personalizată',
      placeholder: 'Introduceți sursa',
    },
    target_product: {
      label: 'Destinație',
      placeholder: 'Selectați destinația',
    },
    target_url: {
      label: 'URL destinație',
      placeholder: 'https://google.com',
    },
    utm_medium: {
      label: 'Mediu',
      placeholder: 'Introduceți mediul',
    },
    utm_campaign: {
      label: 'Campanie',
      placeholder: 'Introduceți campania',
    },
  },
  fields: {
    utm_source: 'Sursă',
    target_product: 'Destinație',
    type: 'Tip',
    utm_medium: 'Mediu',
    utm_campaign: 'Campanie',
    utm_referrer_id: 'ID referrer',
  },
  buttons: {
    create_auto_links: 'Creare linkuri automate',
    create_link: 'Creare link',
    create: 'Creare',
    update: 'Actualizare',
    copy_link: 'Copiere link',
    download_qr_code: 'Descărcare cod QR',
    edit: 'Editare',
  },
  modals: {
    auto_links_creation: {
      title: 'Sigur doriți?',
      description:
        'Asigurați-vă că ați finalizat configurarea magazinului (subdomeniu shop online / domeniu storefront); modificarea acestora după crearea linkurilor nu va afecta automat linkurile existente!',
    },
  },
  toasts: {
    failed_to_load_data: 'Încărcarea datelor a eșuat',
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    changes_got_saved: 'Modificările au fost salvate',
    link_got_copied: 'Linkul a fost copiat!',
    failed_to_download_qr_code: 'Descărcarea codului QR a eșuat',
  },
};
